import{icon as e}from"@godown/element";const t=e(`0 0 256 256`)`<path fill="currentColor" d="m181.66 133.66l-80 80a8 8 0 0 1-11.32-11.32L164.69 128L90.34 53.66a8 8 0 0 1 11.32-11.32l80 80a8 8 0 0 1 0 11.32">`;export{t as default};
//# sourceMappingURL=caret-right.js.map
